export default [{
  name: 'motos',
  namespaced: true,
  state: {
    model: {
      selecionado: {},
      Pessoa: {
        TipoPessoa: 1,
        PF: {},
        PJ: {},
        PessoaDadosContato: {},
        PessoaDadoFinanceiro: {},
        PessoaEndereco: {},
        PessoaQualificacao: {},
      },
      PropostaDadosVeiculo: {
        TipoVeiculo: 2
      }
    }
  },
  mutations: {
    model (state, obj) {
      state.model = obj
    }
  },
  getters: {
    model (state) {
      return state.model
    }
  },
  actions: {
    clearModel ({ commit }) {
      const data = {
        selecionado: {},
        Pessoa: {
          TipoPessoa: 1,
          PF: {},
          PJ: {},
          PessoaDadosContato: {},
          PessoaDadoFinanceiro: {},
          PessoaEndereco: {},
          PessoaQualificacao: {}
        },
        PropostaDadosVeiculo: {}
      }
      commit('model', data)
    }
  }
}]
